import {Component, Input, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute} from "@angular/router";
import {SummaryModel} from "./summary.model";
import {TranslateService} from "@ngx-translate/core";


@Component({
    selector: 'summary',
    templateUrl: 'summary.component.html'
})
export class SummaryComponent implements OnInit {

    public loading: boolean = true;
    @Input() summary : SummaryModel = new SummaryModel();

    constructor(private http: HttpClient, private route: ActivatedRoute, private translate: TranslateService)  {
    }

    ngOnInit() {
        var link = this.route.snapshot.paramMap.get('link');
        this.http.get<SummaryModel>(`/api/summary/${link}`).subscribe(data => {
            this.translate.setDefaultLang(data.language.toLowerCase());
            this.summary = data;
            this.loading = false;
        });
    }

    reservationNo() {
        return {reservationNo: this.summary.reservationNo}
    }

    defaultParams() {
        return {
            reservationNo: this.summary.reservationNo,
            status: this.translate.instant(this.summary.status)
        }
    }
}